Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _withStyles = require('../themes/withStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint jsx-a11y/label-has-for: 1 */

var POSITION_OPTIONS = ['static', 'absolute', 'fixed', 'relative', 'initial', 'inherit'];

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  children: _propTypes2['default'].node.isRequired,
  htmlFor: _propTypes2['default'].string.isRequired,
  id: _propTypes2['default'].string,
  inline: _propTypes2['default'].bool,
  table: _propTypes2['default'].bool,
  position: _propTypes2['default'].oneOf(POSITION_OPTIONS)
}));

var defaultProps = {
  id: undefined,
  inline: false,
  table: false,
  position: undefined
};

function Label(_ref) {
  var css = _ref.css,
      htmlFor = _ref.htmlFor,
      id = _ref.id,
      inline = _ref.inline,
      table = _ref.table,
      position = _ref.position,
      children = _ref.children,
      styles = _ref.styles;

  var labelContent = children;

  if (table) {
    labelContent = _react2['default'].createElement(
      'div',
      css(styles.tableRow),
      children
    );
  }

  return _react2['default'].createElement(
    'label',
    _extends({}, css(styles.container, inline && styles.inline, table && styles.table, position && { position: position }), {
      htmlFor: htmlFor,
      id: id
    }),
    labelContent
  );
}

Label.componentCategory = 'Core';
Label.displayName = 'Label';
Label.propTypes = propTypes;
Label.defaultProps = defaultProps;

exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
  var color = _ref2.color;
  return {
    container: {
      background: color.clear,
      border: 0,
      cursor: 'pointer',
      display: 'block',
      padding: 0
    },

    inline: {
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },

    table: {
      display: 'table'
    },

    tableRow: {
      display: 'table-row'
    }
  };
})(Label);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Label.js
// module id = 411
// module chunks = 923280921217